<!--
 * @Author: cgh
 * @Date: 2022-09-23
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-18 11:33:38
 * @Description: 成员信息添加、修改窗口
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-60 o-dialog--xl-50"
    title="添加"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        label-position="right"
        label-width="150px"
        label-suffix="："
        :validate-on-rule-change="false"
      >
        <el-row class="c-form__row">
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="机构名称"
              prop="userVO.userName"
            >
              <el-input
                v-model.trim="fd.userVO.userName"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="账号类型"
              prop="userVO.SFZZH"
            >
              <el-radio-group
                v-model="fd.userVO.SFZZH"
                class="c-form__radio-group"
              >
                <el-radio label="Y">
                  主账号
                </el-radio>
                <el-radio label="N">
                  公司子账号
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="所属部门"
              prop="capacityVO.deptCode"
            >
              <hm-tree-select
                v-model="fd.capacityVO.deptCode"
                :append-to-body="true"
                class="c-form__hm-tree-select c-tree-select-wrap"
                :normalizer="normalizer"
                :options="bmList"
                :load-options="loadOptions"
                instance-id="cTreeSelect"
                placeholder="请选择机构部门"
                loading-text="加载中..."
                retry-text="重新加载"
                retry-title="点击重新加载"
                no-children-text="没有子节点"
                no-options-text="没有可用选项"
                no-results-text="没有匹配的结果"
                search-prompt-text="查找中..."
                :clearable="false"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="联系人"
              prop="userVO.LXR"
            >
              <el-input
                v-model.trim="fd.userVO.LXR"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="联系电话"
              prop="userVO.tel"
            >
              <el-input
                v-model.trim="fd.userVO.tel"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="创建时间"
              prop="userVO.createTime"
            >
              <span
                class="c-form__read"
              >
                {{ new Date() | date('yyyy-MM-dd') }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="身份有效期止"
              prop="capacityVO.effectEndDate"
            >
              <el-date-picker
                v-model="fd.capacityVO.effectEndDate"
                class="c-form__date"
                type="date"
                placeholder="选择日期"
                value-format="timestamp"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="备注"
              prop="userVO.BZ"
            >
              <el-input
                v-model.trim="fd.userVO.BZ"
                type="textarea"
                :rows="3"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave()"
      />

      <el-button @click="closeDialog()">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { userService, roleCapacityService, accountService } from '../account.service.js';

import AddUser from '@/features/system/attr/user/addUser.vue';
// 继承于新增用户
export default {
  name: 'AddDialog',
  extends: AddUser,
  data () {
    return {
      dialogShow: true, // 模态框dialog显示

      loading: false, // 页面是否加载
      /* 表单参数 Start */

      disabled: false,
      showDialogName: null,
      /* 表单校验规则 Start */
      fdRules: {
        'userVO.userName': [
          this.$validUtils.required('用户名称'),
          this.$HMValidator.maxLength('用户名称', 75)
        ],
        'userVO.tel': [
          this.$validUtils.required('联系电话'),
          this.$HMValidator.maxLength('联系电话', 11)
        ],
        'userVO.LXR': [
          this.$validUtils.required('联系人'),
          this.$HMValidator.maxLength('联系人', 75)
        ],
        'capacityVO.effectEndDate': [
          this.$validUtils.required('身份有效期止'),
          this.$HMValidator.endTime(this, 'fd', 'capacityVO.effectStartDate', ['身份有效期起', '身份有效期止'])
        ],
        'capacityVO.deptCode': [
          this.$validUtils.required('所属组织')
        ],
        'userVO.SFZZH': [
          this.$validUtils.required('账号类型')
        ]
      },
      /* 表单校验规则 End */
      deptRoleUuid: [], // 关联角色：主账号companyManage/子账号projectsManage
      bmList: [] // 部门列表

    };
  },
  methods: {
    normalizer (node) {
      if (node.childNodes == null || node.childNodes.length === 0) {
        return {
          id: node.deptCode,
          label: node.deptName,
          children: node.children
        };
      }
    },
    /**
     * 获取部门列表
     */
    getDeptList () {
      accountService.deptTree()
        .then(rsp => {
          this.bmList = rsp.data.map(item => {
            if (item.xjbz) {
              delete item.xjbz;
              item.children = null;
            }
            return item;
          });
        })
        .catch(err => {
          console.error('获取部门列表出错', err);
        }).finally(() => {
          this.loading = false;
        }); ;
    },
    /**
     * @description: 异步加载下拉树
     * @param {*}
     * @return {*}
     */
    loadOptions ({ action, parentNode, callback }) {
      accountService.deptTree({ deptCode: parentNode.deptCode })
        .then(rsp => {
          parentNode.children = rsp.data.map(item => {
            if (item.xjbz) {
              delete item.xjbz;
              item.children = null;
            }
            return item;
          });
          callback();
        }).catch(() => {
          callback(new Error('机构部门加载失败！'));
        });
    },
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    handleSave () {
      // this.fd.userVO.userCode = this.fd.userVO.tel;
      // this.fd.userAuthVO.account = this.fd.userVO.tel;
      this.fd.userVO.attrs.SFZZH = this.fd.userVO.SFZZH || 'N';
      // this.fd.capacityVO.capacityCode = this.fd.userVO.tel;
      this.fd.userVO.attrs.BZ = this.fd.userVO.BZ;
      this.fd.userVO.attrs.LXR = this.fd.userVO.LXR;
      // this.fd.capacityVO. = new Date();
      this.fd.userAuthVO.effectStartDate = new Date();
      this.fd.userAuthVO.effectEndDate = new Date('9999-12-30');
      this.$refs.fd.validate((valid) => {
        if (valid) {
          this.loading = true;
          // 如果是新增用户，调用新增用户接口
          if (!this.editCapacityVo) {
            // 单身份的身份名称使用用户名称值替代 start
            this.fd.capacityVO.capacityName = this.fd.userVO.userName;
            this.fd.userAuthVO.pwd = this.$config.initPwd;
            // 单身份的身份名称使用用户名称值替代 end
            userService.save(this.fd)
              .then(rsp => {
                this.fd.userVO.userCode = rsp.data.data;
                this.fd.userAuthVO.account = rsp.data.data;
                this.fd.capacityVO.capacityCode = rsp.data.data;
                this.deptRoleUuid.push(rsp.data.deptRoleUuid);
                this.handleSaveRole();
              })
              .catch(err => {
                console.error('用户新增出错！', err);
              }).finally(() => {
                this.loading = false;
              }); ;
          } else {
            // 单身份不会创建新身份
            this.$alert('用户已存在！', '提示', {
              confirmButtonText: '确定',
              type: 'warning',
              callback: action => {
              }
            });
            this.loading = false;
          }
        }
      });
    },
    // /**
    //  * @description: 查询所有可关联岗位列表
    //  * @param {*}
    //  * @return {*}
    //  */
    // getRoleCode (_userCode, _deptCode) {
    //   this.loading = true;
    //   roleCapacityService.getWglRoleList(_userCode, _deptCode)
    //     .then(rsp => {
    //       rsp.data.list.forEach((item) => {
    //         if ((this.fd.userVO.SFZZH === 'Y' && item.roleCode === 'companyManage') ||
    //           ((!this.fd.userVO.SFZZH || this.fd.userVO.SFZZH === 'N') && item.roleCode === 'projectsManage')) {
    //           this.deptRoleUuid.push(item.deptRoleUuid);
    //         }
    //       });
    //     })
    //     .catch(err => {
    //       console.error('获取岗位信息错误', err);
    //     })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // },
    /**
     * @description: 岗位关联保存操作
     * @param {*}
     * @return {*}
     */
    handleSaveRole () {
      this.loading = true;
      roleCapacityService.save({
        capacityCode: this.fd.userVO.userCode, // 用户身份uuid
        deptRoleUuid: this.deptRoleUuid // 已关联岗位uuid
      })
        .then(rsp => {
          this.$alert('新增成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.log('岗位关联保存错误', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }

  },
  created () {
    this.$set(this.fd, 'roleList', []);
    // const currentUser = this.$HMStoreService.getUserinfo();
    // this.roleFilter.userCode = currentUser.capacity.capacityCode;
    // this.roleFilter.deptCode = currentUser.capacity.deptCode;
    this.fd.capacityVO.effectStartDate = new Date();
    // 获取部门列表
    this.getDeptList();
  }
};
</script>
